import { Box, Center, Container, Spinner, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import EventCategoriesSidebarContainer from 'presentation/containers/modules/event/EventCategoriesSidebarContainer';
import SidebarLayout, {
  sidebarWidth,
} from 'presentation/layout/shared/SidebarLayout';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchProfileQuery } from 'rtkQuery/sharespro/queries/profile';
import EventsPageLayout from 'presentation/layout/modules/events/EventsPageLayout';
import PersonalManagerChatCard from 'presentation/containers/modules/chat/detail/PersonalManagerChatCard';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';

const PrivateChannelLayout: FC<PropsWithChildren> = ({ children }) => {
  const { data: profile, error, refetch } = useFetchProfileQuery();

  const { t } = useTranslation();

  let content;
  let wrapByCard = true;
  if (profile) {
    if (profile.isPrivateChannelAllowed) {
      content = children;
      wrapByCard = false;
    } else {
      content = <Text>{t('noAccess')}</Text>;
    }
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (wrapByCard) {
    content = (
      <AppCard p="20">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <EventsPageLayout>
      <Container display="flex" alignItems="flex-start">
        <SidebarLayout>
          <EventCategoriesSidebarContainer />
          <PersonalManagerChatCard
            mt="20px"
            roomType={ChatRoomType.CommunityManager}
          />
        </SidebarLayout>
        <Box flex="1" w={`calc(100% - ${sidebarWidth}px - 20px)`}>
          {content}
        </Box>
      </Container>
    </EventsPageLayout>
  );
};

export default PrivateChannelLayout;
